import { ViewModel,View, ObservableArray } from "binder"
import { SearchableSelectorBaseViewModel } from "src/common/reusableComponents/searchableSelectorBase/searchableSelectorBase-viewModel";
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import  { PncManipulationView } from "./pncManipulation-view"

export class PncManipulationViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'مدیریت PNC ها ‌';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.pncs = ObservableArray.create<pnc>();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),15);
        this.refresh();
    }
    GetDefaultView(): View <ViewModel> {
        return new PncManipulationView();
    }
    public getTypeId(): string {
        return "VM-D5B5B64E-5F31-4E5E-8B8E-3093215687DD"
    }
    public set pncs(v: ObservableArray<pnc>) { this._pncs = v; } public get pncs(): ObservableArray<pnc> { return this._pncs;} private _pncs: ObservableArray<pnc>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    
    refresh(){
        this.loader.refresh();
    }
    async refreshPaged(filteringInformation:any): Promise<PaginationInfo>{
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/GetAllPnc',{
                FilteringInformation:filteringInformation
            });
            this.pncs.update(...result.Pnc.map(q=>{
                let r = new pnc(this);
                r.id = q.Id;
                r.name = q.Name;
                r.code = q.Code;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }
    
    async requestPncCreation(){
        let editor = new pncEditor(this,new InsertServerUpdater());
        let resultCode = await this.showPopup(editor);
        if(resultCode=='done'){
            this.loader.refresh();
        }
    }
    
    async pncUpdater(pnc:pnc){
        let editor = new pncEditor(this,new UpdateServerUpdater());
        pnc.cloneTo(editor);
        let resultCode = await this.showPopup(editor);
        if(resultCode=='done'){
            this.loader.refresh();
        }
    }
}

export class pnc extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:PncManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
        
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code;} private _code: string;
    
    private _typedParent:PncManipulationViewModel;

    clone(parent:PncManipulationViewModel):pnc{
        let u = new pnc(parent);
        this.cloneTo(u);
        return u;
    }

    cloneTo(pnc:pnc){
        pnc.id = this.id;
        pnc.name = this.name;
        pnc.code = this.code;
    }

    async edit(){
        this._typedParent.pncUpdater(this);
    }    
}

interface IServerUpdater{
    execute(pnc:pnc):Promise<void>;
    getSuccessMessage():string;
}

class InsertServerUpdater implements IServerUpdater{
    getSuccessMessage(): string {
        return 'PNC با موفقیت ثبت شد.';
    }
    async execute(pnc: pnc): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/WarehouseServices/CreatePnc',{
            Name:pnc.name,
            Code:pnc.code
        });
        if(result.IsSuccessful==false){
            throw "new Error";
        }
    }
}
class UpdateServerUpdater implements IServerUpdater{
    getSuccessMessage(): string {
        return 'PNC با موفقیت به روز رسانی شد.';

    }
    async execute(pnc: pnc): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/WarehouseServices/UpdatePnc',{
            Id:pnc.id,
            Name:pnc.name,
            Code:pnc.code
        });
        if(result.IsSuccessful==false){
            throw "new Error";
        }
    }
}

export class pncEditor extends pnc implements IPopup{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}

    constructor(parent:PncManipulationViewModel,serverUpdater:IServerUpdater) {
        super(parent);
        this._serverUpdater = serverUpdater;
        
    }
    closePopup(resultCode: string = null) {
    }
    
    private _serverUpdater:IServerUpdater;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    verify():string[]{
        let result :string[] =[];
        if(stringIsNullOrEmpty(this.name)){
            result.push('نام PNC مشخص نشده است.')
        } 
        if(stringIsNullOrEmpty(this.code)){
            result.push('کد PNC مشخص نشده است.')
        }
        return result;
    }

    async save(){
        try {
            let verificationResult = this.verify();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'عدم امکان ثبت PNC');
                return;
            }
            this.isLoading = true;
            await this._serverUpdater.execute(this);
            await this.messageBoxConfirmSuccess(this._serverUpdater.getSuccessMessage(),'عملیات موفق');
            this.closePopup("done")
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
        }
    }

    back(){
        this.closePopup();
    }
}

export class PncSelectorSearchableViewModel extends SearchableSelectorBaseViewModel<pncForSelector>{
    protected async loadData(searchedText: string): Promise<pncForSelector[]> {
        let result = await ServerConnection.callServer('Complex/WarehouseServices/SearchPnc',{
            SearchText:searchedText,
            ResultCount:20,
        });
        return result.Pncs.map(x=>this.convertSingle(x));
    }
    protected async loadById(id: string): Promise<pncForSelector> {
        let result = await ServerConnection.callServer('Complex/WarehouseServices/SearchPncById',{
            Id:id
        });    
        return this.convertSingle(result.Product);
    }
    private convertSingle(dto:any):pncForSelector{
        var p = new pncForSelector(this);
        p.id = dto.Id;
        p.pncName = dto.Name;
        p.code = dto.Code;
        p.title = `${dto.Code} (${dto.Name})`;
        return p;
    }
}

class pncForSelector extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);   
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
    public set pncName(v: string) { this._pncName = v; } public get pncName(): string { return this._pncName;} private _pncName: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code;} private _code: string;
    
}
